import { useEffect, useState } from "react";
import Shell from "../components/Shell";
import { api } from "../lib/api";
import { Users, Video } from "lucide-react";

export default function WarRoom() {
  const [info, setInfo] = useState(null);
  const [joined, setJoined] = useState(false);

  useEffect(() => { api.get("/war-room/info").then((r) => setInfo(r.data)); }, []);

  const jitsiUrl = info ? `https://${info.jitsi_domain}/${info.room_name}#userInfo.displayName=%22${encodeURIComponent(info.display_name)}%22&config.prejoinPageEnabled=false` : "";

  return (
    <Shell>
      <div className="p-4 sm:p-8" data-testid="war-room-page">
        <div className="label-xs flex items-center gap-2 text-live">
          <span className="w-1.5 h-1.5 bg-live rounded-full pulse-live"></span>
          <span>LIVE · AGENCY_WAR_ROOM</span>
        </div>
        <h1 className="font-display text-3xl sm:text-5xl leading-none mt-2">War Room.</h1>
        <p className="mt-2 text-fg-muted font-mono text-sm">Virtual office · group dial sessions · presence = accountability.</p>

        {!joined ? (
          <div className="mt-8 border border-term bg-raised p-12 text-center scanline">
            <Video size={36} strokeWidth={1.5} className="mx-auto text-amber" />
            <div className="font-display text-2xl mt-4">Ready to dial together?</div>
            <div className="text-xs text-fg-muted mt-2 max-w-md mx-auto font-mono uppercase tracking-widest">
              JOIN THE SHARED AGENCY ROOM. POWER HOURS HIT HARDER TOGETHER.
            </div>
            <button onClick={() => setJoined(true)} className="btn-primary mt-8 mx-auto" data-testid="join-war-room-btn">
              <Users size={14} /> Enter War Room
            </button>

            <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-px bg-term border border-term text-left">
              <div className="bg-raised p-5">
                <div className="label-xs text-amber">// RULE_01</div>
                <div className="font-bold mt-1 text-fg">Mic on mute between calls.</div>
              </div>
              <div className="bg-raised p-5">
                <div className="label-xs text-amber">// RULE_02</div>
                <div className="font-bold mt-1 text-fg">Camera on. Show up.</div>
              </div>
              <div className="bg-raised p-5">
                <div className="label-xs text-amber">// RULE_03</div>
                <div className="font-bold mt-1 text-fg">Sale? Ring the bell.</div>
              </div>
            </div>
          </div>
        ) : (
          <div className="mt-6 border border-term bg-black" data-testid="war-room-embed">
            <iframe
              title="War Room"
              src={jitsiUrl}
              allow="camera; microphone; fullscreen; display-capture; autoplay"
              className="w-full h-[70vh] border-0 block"
            />
            <div className="p-3 flex justify-between items-center text-[10px] text-fg-muted font-mono uppercase tracking-widest">
              <span>ROOM: {info?.room_name}</span>
              <button onClick={() => setJoined(false)} className="text-live hover:underline" data-testid="leave-war-room-btn">Leave &gt;</button>
            </div>
          </div>
        )}
      </div>
    </Shell>
  );
}
